import Vue from 'vue'
import FileManager from 'laravel-file-manager'
import 'laravel-file-manager/dist/css/app.37b7e917.css'

import store from '@/store'

Vue.use(FileManager, { store })
